import { useState, useEffect } from "react";
import { DownArrowChevron, LeftArrowIcon, } from "../../../../assets/icons/svgicons";
import Button from "../../Button/Button";
import Modal from "../Modal/Modal";
import styles from "./MakePayment.module.scss";
import PaymentOptionsModal from "../PaymentOptionsModal/PaymentOptionsModal";
import PaymentSummaryModal from "../PaymentSummaryModal/PaymentSummaryModal";
import { format } from "date-fns";
import { formatPrice } from "../../../../utils/utils";
import ErrorText from "../../Formik/ErrorText/ErrorText";
import { useSelector } from "react-redux";
const RedeemMakePayment = ({
  show, handleClose, redeemData, shippingFee, resetForm, shippedFee,
}) => {
  const [showPaymentOptions, setShowPaymentOptions] = useState(false);
  const [showPaymentSummary, setShowPaymentSummary] = useState(false);
  const [paymentMode, setPaymentMode] = useState("");
  const [error, setError] = useState("");
  const commonBalance = useSelector(
    (state) => state?.users?.commonWalletBalance?.amount
  );

  // const handleMakePayment = () => {
  //   if (paymentMode) {
  //     setShowPaymentSummary(true);
  //     handleClose();
  //   } else {
  //     setError("Please select payment mode");
  //   }
  // };
  const handleMakePayment = () => {
    setShowPaymentSummary(true);
    handleClose();
  };

  useEffect(() => {
    if (paymentMode) {
      setError("");
    }
  }, [paymentMode]);

  return (
    <>
      <Modal
        show={show}
        handleClose={handleClose}
        className={`${styles.match_modal} ${styles.confirmpaymodal}`}
        title={
          <span
            onClick={() => {
              handleClose();
            }}
          >
            <LeftArrowIcon />
            Back
          </span>
        }
        hideCloseBtn
      >
        <div className={styles.match_modal_body}>
          <h2>Please make the payment!</h2>
          <h6 className={`${styles.sub_text} ${styles.redeem_sub_text}`}>
            Pay the premium fee to claim the delivery of the coin.
            Delivery Address: {redeemData?.shippingAddress}{" "}
          </h6>
          <div className={styles.payment_method}>
            <div>
              <h6>Pay Exactly for</h6>
              <h2>${formatPrice(Number(shippingFee))}</h2>
              <h6>(Do not round off)</h6>
            </div>
            {/* <button
              onClick={() => {
                setShowPaymentOptions(true);
                handleClose(false);
              }}
            >
              <span>
                Pay with
                <strong className="h1">
                  {paymentMode ? paymentMode : "Select"} Wallet
                </strong>
              </span>
              <DownArrowChevron />
            </button> */}

            <div>
              <h6>STBL Wallet Bal:</h6>
              <h4 className={styles.stbl_wallet}>
                {" "}
                <span className="commonBal">
                  ${formatPrice(Number(commonBalance))}
                </span>
              </h4>
            </div>
          </div>
          {error && <ErrorText>{error}</ErrorText>}
          <Button
            fluid
            className={styles.submit_btn}
            onClick={handleMakePayment}
          >
            Make Payment
          </Button>
          <h6>
            Time taken depends on current demand & your price. <br />
            Placed on {format(new Date(), "dd MMM, yyyy, HH:mm")}{" "}
          </h6>
        </div>
      </Modal>
      <PaymentOptionsModal
        show={showPaymentOptions}
        shippingFee={shippingFee}
        paymentMode={paymentMode}
        setPaymentMode={setPaymentMode}
        handleWalletOptionsModal={handleClose}
        handleClose={() => setShowPaymentOptions(false)}
      />
      <PaymentSummaryModal
        show={showPaymentSummary}
        handleClose={() => setShowPaymentSummary(false)}
        redeemData={redeemData}
        paymentMode={paymentMode}
        resetForm={resetForm}
        shippedFee={shippedFee}
      />
    </>
  );
};

export default RedeemMakePayment;
